import { call, put, select } from 'redux-saga/effects';
import { ObrasApi } from 'Data/Obras.api';
import toastHandler from 'Utils/toastHandler';
import {
  ObraActions,
  GetObraAction,
  CreateAction,
  UpdateArchivedStatusAction,
  GetUsersConstructionSiteAction,
  BindUsersConstructionSiteAction,
  UpdateConstructionSiteApiAction,
  UpdateDetailsAction,
  UpdateDisciplinesAction,
  UpdateUsersAction,
  DeleteUsersAction,
  UpdateInvitedUsersAction,
  DeleteInvitedUsersAction,
  UpdatePermissionsAction,
  UpdateNomenclatureAction,
  ListStagesAction,
  CreateStagesAction,
  UpdateStagesAction,
  DeleteStagesAction,
  ImportLibraryAction,
  SettingsStagesAction,
  OrderStagesAction,
} from './Obra.actions';
import {
  loadError,
  updateError,
  createError,
  listAllTenantOfUserError,
} from 'Utils/Messages';
import { AuthActions } from 'Store/Auth/Auth.actions';
import { IUserLimitsActive } from 'Store/Auth/interfaces/IAuthState';
import { IGlobalReducerState } from 'Store/Base/interface/IGlobalReducerState';
import { Mixpanel } from 'Utils/MixPanel';
import { IObraListResponse } from 'Data/interfaces/Obra/IObraListResponse';
import { DisciplinaActions } from 'Store/Disciplina/Disciplina.actions';
import { ListagemArquivosActions } from 'Store/ListagemArquivos/ListagemArquivos.actions';
import { ObrasApiV2 } from 'Data/Obras.api.v2';
import {
  IObraDetailsUpdate,
  IObraDetailsResponse,
} from 'Data/interfaces/Obra/IObraDetails';
import {
  ICreateStageResponse,
  IOrderStageResponse,
  IUpdateStageResponse,
} from 'Data/interfaces/Obra/IObraStages';
import { ActivitiesActions } from 'Store/Activities/Activities.actions';
import { navigationService } from 'Utils/Navigation';
import { queryClient } from 'Utils/queryClient';
import { OBRA_FETCH_QUERY_KEY, OBRA_QUERY_KEY } from 'Data/keys/QueryKeys';

export function* list() {
  try {
    const { data } = yield call(ObrasApi.list);
    const response: IObraListResponse = { ObrasList: data.data };
    yield put(ObraActions.listSuccess(response));
  } catch {
    yield put(ObraActions.listFailure('Erro ao carregar obras'));
  }
}

export function* getObra({ payload }: GetObraAction) {
  try {
    const { data } = yield call(ObrasApi.getConstructionSite, payload);
    yield put(ObraActions.getObraSuccess(data.data));
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : loadError('obras');
    toastHandler.showError(error);
    yield put(ObraActions.getObraFailure(error));
  }
}

export function* createOrUpdate({ payload }: CreateAction) {
  try {
    const {
      firstObraTracking,
      userInfoTracking,
      currentTenantTracking,
      tenantIds,
    } = payload;
    delete payload.firstObraTracking;
    delete payload.userInfoTracking;
    delete payload.currentTenantTracking;
    delete payload.tenantIds;

    const {
      tenantInvitedUsers,
      tenantUsers,
    } = yield select((state: IGlobalReducerState) => state.tenant.UsersWithConstruction);
    yield put(ObraActions.addObraChunckData(payload));

    if (payload.shouldSendData) {
      // @ts-ignore:next-line
      const obra = yield select((state: IGlobalReducerState) => state.obra.Obra);
      let userLimitsActive: IUserLimitsActive;

      const filterSharedUsers = tenantUsers?.filter((user: any) => user.User.Id !== userInfoTracking?.Id);
      const isFirstUser = ((tenantInvitedUsers?.length || 0) <= 0) &&
        ((filterSharedUsers?.length || 0) <= 0) &&
        obra?.InvitedUsers?.length > 0;

      if (obra.ConstructionSiteId) {
        const { data } = yield call(ObrasApi.update, obra);
        yield queryClient.invalidateQueries({ queryKey: [OBRA_QUERY_KEY] });
        yield queryClient.invalidateQueries({ queryKey: [OBRA_FETCH_QUERY_KEY] });
        yield put(ObraActions.createOrUpdateSuccess(data.data.Value.data));
        yield put(DisciplinaActions.listSuccess(data.data.Value.data));
        yield put(ListagemArquivosActions.addObraChunckData(data.data.Value.data));

        if (isFirstUser) {
          Mixpanel.track({
            name: 'INVITED_FIRST_USER',
            props: { constructionSiteId: data.data.ConstructionSiteId },
            userInfo: userInfoTracking,
            currentListTenant: currentTenantTracking,
            tenantIds,
          });
        }

        userLimitsActive = {
          QtyActiveUsers: obra?.InvitedUsers?.filter((newUsers: any) => {
            return !tenantInvitedUsers.map((user: any) => user.InvitedUserEmail).includes(newUsers.Email);
          }).length || undefined,
        };
        yield put(AuthActions.toogleUserLimitsActive(userLimitsActive));

        toastHandler.showSuccess('Obra Atualizada com sucesso!');

      } else {
        const { data } = yield call(ObrasApi.create, obra);
        yield queryClient.invalidateQueries({ queryKey: [OBRA_QUERY_KEY] });
        yield queryClient.invalidateQueries({ queryKey: [OBRA_FETCH_QUERY_KEY] });
        yield put(ObraActions.list());

        if (firstObraTracking) {
          Mixpanel.track({
            name: 'CREATE_FIRST_OBRA',
            props: { constructionSiteId: data.data.ConstructionSiteId },
            userInfo: userInfoTracking,
            currentListTenant: currentTenantTracking,
            tenantIds,
          });
        }
        if (isFirstUser) {
          Mixpanel.track({
            name: 'INVITED_FIRST_USER',
            props: { constructionSiteId: data.data.ConstructionSiteId },
            userInfo: userInfoTracking,
            currentListTenant: currentTenantTracking,
            tenantIds,
          });
        }

        userLimitsActive = {
          QtyActiveConstructionSites: 1,
          QtyActiveUsers: obra?.InvitedUsers?.filter((newUsers: any) => {
            return !tenantInvitedUsers.map((user: any) => user.InvitedUserEmail).includes(newUsers.Email);
          }).length || undefined,
        };
        yield put(AuthActions.toogleUserLimitsActive(userLimitsActive));

        if (obra.ExistingConstructionSiteTokenId) {
          navigationService.push(`/obras/detail/${data.data.ConstructionSiteId}/true`);
        } else {
          window.location.href = data.info.redirectUrl;
        }
      }
    }
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : createError('obra');
    toastHandler.showError(error);
    yield put(ObraActions.createOrUpdateFailure(error));
  }
}

export function* updateArchivedStatus({ payload }: UpdateArchivedStatusAction) {
  try {
    yield call(ObrasApi.updateArchivedStatus, payload);
    yield queryClient.invalidateQueries({ queryKey: [OBRA_QUERY_KEY] });
    yield queryClient.invalidateQueries({ queryKey: [OBRA_FETCH_QUERY_KEY] });
    yield put(ObraActions.updateArchivedStatusSuccess(payload));

    let userLimitsActive: IUserLimitsActive;
    if (payload.isArchived) {
      userLimitsActive = {
        QtyActiveConstructionSites: -1,
      };
    } else {
      userLimitsActive = {
        QtyActiveConstructionSites: 1,
      };
    }
    yield put(AuthActions.toogleUserLimitsActive(userLimitsActive));

    navigationService.push(`/obras`);
    toastHandler.showSuccess('Obra arquivada/desarquivada com sucesso');
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : 'Erro ao arquivar/desarquivar obra';
    toastHandler.showError(error);
    yield put(ObraActions.updateArchivedStatusFailure(error));
  }
}

export function* getDisciplines() {
  try {
    const { data } = yield call(ObrasApi.getDisciplines);
    yield put(ObraActions.getDisciplinesSuccess(data.data));
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : loadError('disciplinas');
    toastHandler.showError(error);
    yield put(ObraActions.getDisciplinesFailure(error));
  }
}

export function* getUsersConstructionSite({ payload }: GetUsersConstructionSiteAction) {
  try {
    const { data } = yield call(ObrasApi.getUserByConstructionSite, payload);
    const response = data.data;
    response.ConstructionSiteId = payload;
    yield put(ObraActions.getUsersConstructionSiteSuccess(response));
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : loadError('usuários da Obra');
    toastHandler.showError(error);
    yield put(ObraActions.getUsersConstructionSiteFailure(error));
  }
}

export function* bindUsersConstructionSite({ payload }: BindUsersConstructionSiteAction) {
  try {
    const {
      firstUserTracking,
      userInfoTracking,
      currentTenantTracking,
      tenantIds,
    } = payload;
    delete payload.firstUserTracking;
    delete payload.userInfoTracking;
    delete payload.currentTenantTracking;
    delete payload.tenantIds;

    yield call(ObrasApi.bindUsersToConstructionSite, payload);
    yield queryClient.invalidateQueries({ queryKey: [OBRA_QUERY_KEY] });
    yield queryClient.invalidateQueries({ queryKey: [OBRA_FETCH_QUERY_KEY] });
    yield put(ObraActions.bindUsersConstructionSiteSuccess(payload));

    const userLimitsActive: IUserLimitsActive = {
      QtyActiveUsers: payload.newInvitedUsers,
    };

    if (firstUserTracking) {
      Mixpanel.track({
        name: 'INVITED_FIRST_USER',
        props: { constructionSiteId: payload.ConstructionSiteId },
        userInfo: userInfoTracking,
        currentListTenant: currentTenantTracking,
        tenantIds,
      });
    }
    yield put(AuthActions.toogleUserLimitsActive(userLimitsActive));

    toastHandler.showSuccess('Usuários atualizados com sucesso.');
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : updateError('usuários da Obra');
    toastHandler.showError(error);
    yield put(ObraActions.bindUsersConstructionSiteFailure(error));
  }
}

export function* listConstructionSiteAccounts() {
  try {
    const { data } = yield call(ObrasApi.listConstructionSiteAccountsInfo);
    yield put(ObraActions.listConstructionSiteAccountsSuccess(data.data));
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : loadError('contas da construtora');
    toastHandler.showError(error);
    yield put(ObraActions.listConstructionSiteAccountsFailure(error));
  }
}

export function* updateConstructionSiteApi({ payload }: UpdateConstructionSiteApiAction) {
  try {
    const { data } = yield call(ObrasApi.updateConstructionSiteApi, payload);
    yield queryClient.invalidateQueries({ queryKey: [OBRA_QUERY_KEY] });
    yield queryClient.invalidateQueries({ queryKey: [OBRA_FETCH_QUERY_KEY] });
    yield put(ObraActions.list());

    if (payload.isRedirect) {
      if (payload.ExistingConstructionSiteTokenId) {
        navigationService.push(`/obras/detail/${payload.CsId}`);
      } else {
        window.location.href = data.data.redirectUrl;
      }
      yield put(ObraActions.updateArchivedStatusSuccess(data.data));
    } else {
      yield put(ObraActions.listConstructionSitesStorage());
      toastHandler.showSuccess('Obra atualizada com sucesso');
    }
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : updateError('serviço de nuvem');
    toastHandler.showError(error);
    yield put(ObraActions.updateArchivedStatusFailure(error));
  }
}

export function* listConstructionSitesStorage() {
  try {
    const { data } = yield call(ObrasApi.listConstructionSitesStorage);
    yield put(ObraActions.listConstructionSitesStorageSuccess(data.data));
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : loadError('contas da construtora');
    toastHandler.showError(error);
    yield put(ObraActions.listConstructionSitesStorageFailure(error));
  }
}

export function* listAllConstructionsSitesOfUser() {
  try {
    const { data } = yield call(ObrasApi.fetchAllConstructionsOfUser);
    yield put(ObraActions.listAllConstructionsSitesOfUserSuccess(data.data));
  } catch (err: any) {
    const error = err.errors ? err.errors[0].Message : listAllTenantOfUserError;
    toastHandler.showError(error);
    yield put(ObraActions.listAllConstructionsSitesOfUserFailure(error));
  }
}

export function* updateDetails({ payload }: UpdateDetailsAction) {
  try {
    const request: IObraDetailsUpdate = {
      name: payload.Name,
      type: payload.Type,
      address: payload.Address,
      avatarFileName: payload.AvatarFileName,
    };
    yield call(ObrasApiV2.updateDetails, payload.constructionStieId, request);
    yield queryClient.invalidateQueries({ queryKey: [OBRA_QUERY_KEY] });
    yield queryClient.invalidateQueries({ queryKey: [OBRA_FETCH_QUERY_KEY] });

    const response: IObraDetailsResponse = {
      constructionStieId: payload.constructionStieId,
      name: payload.Name,
      type: payload.Type,
      address: payload.Address,
      avatarFileName: payload.AvatarFileName,
    };
    yield put(ObraActions.updateDetailsSuccess(response));
    toastHandler.showSuccess('Dados da Obra atualizados com sucesso!');
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : 'Erro ao atualizar dados da Obra!';
    toastHandler.showError(error);
    yield put(ObraActions.updateDetailsFailure(error));
  }
}

export function* updateDisciplines({ payload }: UpdateDisciplinesAction) {
  try {
    const { data } = yield call(ObrasApiV2.updateDisciplines, payload);
    yield queryClient.invalidateQueries({ queryKey: [OBRA_QUERY_KEY] });
    yield queryClient.invalidateQueries({ queryKey: [OBRA_FETCH_QUERY_KEY] });

    yield put(ObraActions.updateDisciplinesSuccess({
      constructionStieId: payload.constructionStieId,
      disciplines: data.data,
    }));
    toastHandler.showSuccess('Disciplinas da Obra atualizadas com sucesso!');
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : 'Erro ao atualizar Disciplinas!';
    toastHandler.showError(error);
    yield put(ObraActions.updateDisciplinesFailure(error));
  }
}

export function* updateUsers({ payload }: UpdateUsersAction) {
  try {
    const { data } = yield call(ObrasApiV2.updateUsers, payload);
    yield queryClient.invalidateQueries({ queryKey: [OBRA_QUERY_KEY] });
    yield queryClient.invalidateQueries({ queryKey: [OBRA_FETCH_QUERY_KEY] });

    yield put(ObraActions.updateUsersSuccess({
      constructionStieId: payload.constructionStieId,
      user: data.data,
    }));
    toastHandler.showSuccess('Obra compartilhada com sucesso!');
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : 'Erro ao compartilhar Obra!';
    toastHandler.showError(error);
    yield put(ObraActions.updateUsersFailure(error));
  }
}

export function* deleteUsers({ payload }: DeleteUsersAction) {
  try {
    yield call(ObrasApiV2.deleteUsers, payload);
    yield queryClient.invalidateQueries({ queryKey: [OBRA_QUERY_KEY] });
    yield queryClient.invalidateQueries({ queryKey: [OBRA_FETCH_QUERY_KEY] });

    yield put(ObraActions.deleteUsersSuccess({
      constructionStieId: payload.constructionStieId,
      userId: payload.userId,
    }));
    toastHandler.showSuccess('Compartilhamento da Obra removido com sucesso!');
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : 'Erro ao remover compartilhamento da Obra!';
    toastHandler.showError(error);
    yield put(ObraActions.deleteUsersFailure(error));
  }
}

export function* updateInvitedUsers({ payload }: UpdateInvitedUsersAction) {
  try {
    const { data } = yield call(ObrasApiV2.updateInvitedUsers, payload);
    yield queryClient.invalidateQueries({ queryKey: [OBRA_QUERY_KEY] });
    yield queryClient.invalidateQueries({ queryKey: [OBRA_FETCH_QUERY_KEY] });

    yield put(ObraActions.updateInvitedUsersSuccess({
      constructionStieId: payload.constructionStieId,
      user: data.data,
    }));
    toastHandler.showSuccess('Convite enviado com sucesso!');
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : 'Erro ao convidar usuário!';
    toastHandler.showError(error);
    yield put(ObraActions.updateInvitedUsersFailure(error));
  }
}

export function* deleteInvitedUsers({ payload }: DeleteInvitedUsersAction) {
  try {
    yield call(ObrasApiV2.deleteInvitedUsers, payload);
    yield queryClient.invalidateQueries({ queryKey: [OBRA_QUERY_KEY] });
    yield queryClient.invalidateQueries({ queryKey: [OBRA_FETCH_QUERY_KEY] });

    yield put(ObraActions.deleteInvitedUsersSuccess({
      constructionStieId: payload.constructionStieId,
      invitedEmail: payload.invitedEmail,
    }));
    toastHandler.showSuccess('Compartilhamento removido com sucesso!');
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : 'Erro ao remover compartilhamento!';
    toastHandler.showError(error);
    yield put(ObraActions.deleteInvitedUsersFailure(error));
  }
}

export function* updatePermissionsUsers({ payload }: UpdatePermissionsAction) {
  try {
    yield call(ObrasApiV2.updatePermissions, payload);
    yield queryClient.invalidateQueries({ queryKey: [OBRA_QUERY_KEY] });
    yield queryClient.invalidateQueries({ queryKey: [OBRA_FETCH_QUERY_KEY] });

    yield put(ObraActions.updatePermissionsUsersSuccess({
      constructionStieId: payload.constructionStieId,
      permissions: payload.permissions,
    }));
    toastHandler.showSuccess('Permissões da Obra atualizadas com sucesso!');
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : 'Erro ao atualizar Permissões!';
    toastHandler.showError(error);
    yield put(ObraActions.updatePermissionsUsersFailure(error));
  }
}

export function* updateNomenclatures({ payload }: UpdateNomenclatureAction) {
  try {
    const { data } = yield call(ObrasApiV2.updateNomenclatures, payload);
    yield queryClient.invalidateQueries({ queryKey: [OBRA_QUERY_KEY] });
    yield queryClient.invalidateQueries({ queryKey: [OBRA_FETCH_QUERY_KEY] });

    yield put(ObraActions.updateNomenclatureSuccess({
      constructionStieId: payload.constructionStieId,
      nomenclatures: {
        ...data.data,
        VersionConfigFk: data.data?.VersionConfigId,
      },
    }));
    toastHandler.showSuccess('Nomenclatura da Obra atualizada com sucesso!');
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : 'Erro ao atualizar Nomenclatura!';
    toastHandler.showError(error);
    yield put(ObraActions.updateNomenclatureFailure(error));
  }
}

export function* listStages({ payload }: ListStagesAction) {
  try {
    const { data } = yield call(ObrasApiV2.listStages, payload);

    yield put(ObraActions.listStagesSuccess({
      constructionStieId: payload,
      stages: data.data,
    }));
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : 'Erro ao listar Etapas!';
    toastHandler.showError(error);
    yield put(ObraActions.listStagesFailure(error));
  }
}

export function* createStages({ payload }: CreateStagesAction) {
  try {
    const { data } = yield call(ObrasApiV2.createStages, payload);

    const response: ICreateStageResponse = {
      constructionStieId: payload.constructionStieId,
      stage: data.data,
    };
    yield put(ObraActions.createStagesSuccess(response));
    yield put(ActivitiesActions.createStagesSuccess(response));
    toastHandler.showSuccess('Etapa criada com sucesso!');
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : 'Erro ao criar Etapa!';
    toastHandler.showError(error);
    yield put(ObraActions.createStagesFailure(error));
  }
}

export function* updateStages({ payload }: UpdateStagesAction) {
  try {
    const { data } = yield call(ObrasApiV2.updateStages, payload);

    const response: IUpdateStageResponse = {
      constructionStieId: payload.constructionStieId,
      stage: data.data,
    };
    yield put(ObraActions.updateStagesSuccess(response));
    yield put(ActivitiesActions.updateStagesSuccess(response));
    toastHandler.showSuccess('Etapa atualizada com sucesso!');
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : 'Erro ao atualizar Etapa!';
    toastHandler.showError(error);
    yield put(ObraActions.updateStagesFailure(error));
  }
}

export function* orderStages({ payload }: OrderStagesAction) {
  try {
    yield call(ObrasApiV2.orderStages, payload);

    const response: IOrderStageResponse = {
      constructionStieId: payload.constructionStieId,
      orderedStages: payload.stages,
    };
    yield put(ObraActions.orderStagesSuccess(response));
    toastHandler.showSuccess('Etapa ordenada com sucesso!');
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : 'Erro ao ordenar Etapa!';
    toastHandler.showError(error);
    yield put(ObraActions.orderStagesSuccess(error));
  }
}

export function* deleteStages({ payload }: DeleteStagesAction) {
  try {
    yield call(ObrasApiV2.deleteStages, payload);

    yield put(ObraActions.deleteStagesSuccess({
      constructionStieId: payload.constructionStieId,
      stageId: payload.stageId,
    }));
    toastHandler.showSuccess('Etapa excluída com sucesso!');
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : 'Erro ao excluir Etapa!';
    toastHandler.showError(error);
    yield put(ObraActions.deleteStagesFailure(error));
  }
}

export function* listLibrary() {
  try {
    const { data } = yield call(ObrasApiV2.listLibraries);

    yield put(ObraActions.listLibrarySuccess(data.data));
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : 'Erro ao listar Bibliotecas!';
    toastHandler.showError(error);
    yield put(ObraActions.listLibraryFailure(error));
  }
}

export function* importLibrary({ payload }: ImportLibraryAction) {
  try {
    const { data } = yield call(ObrasApiV2.importLibrary, payload);

    yield put(ObraActions.importLibrarySuccess(data.data));
    toastHandler.showSuccess('Biblioteca importada com sucesso!');
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : 'Erro ao importar Biblioteca!';
    toastHandler.showError(error);
    yield put(ObraActions.importLibraryFailure(error));
  }
}

export function* settingsStages({ payload }: SettingsStagesAction) {
  try {
    yield call(ObrasApiV2.settingsStages, payload);
    yield queryClient.invalidateQueries({ queryKey: [OBRA_QUERY_KEY] });
    yield queryClient.invalidateQueries({ queryKey: [OBRA_FETCH_QUERY_KEY] });

    yield put(ObraActions.settingsStagesSuccess(payload));
    toastHandler.showSuccess('Configuração alterada com sucesso!');
  } catch (e: any) {
    const error = e.errors ? e.errors[0].Message : 'Erro ao editar configuração da Etapa!';
    toastHandler.showError(error);
    yield put(ObraActions.settingsStagesFailure(error));
  }
}
